import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    closeMsgWindow: true,
    unReadNewsCount: 0,
    newState:0//消息状态-1：全部 0：未读 1：已读 
  },
  mutations: {
    changeMsgWindow(state) {
      state.closeMsgWindow = !state.closeMsgWindow
      state.newState = -1
    },
    closeMsgWindow(state) {
      state.closeMsgWindow = false
    },
    openMsgWindow(state) {
      state.closeMsgWindow = true
    },
    changeUnReadNewsCount(state, val) {
      state.unReadNewsCount = val
    },
    initNewState(state) {
      state.newState = 0;
    },
  },
  actions: {
  },
  modules: {
  }

})



// WEBPACK FOOTER //
// ./src/store/index.js